import { IModel } from "@/@types/models/model";

import { coreFields} from "./helpers/coreFields";
import { commonFields } from "./helpers/commonFields";


const Photo360: IModel = {
  title: "Photos 360",
  apiPath: "operations/projekti/{$projekt_id}/photos360",
  forms: {
    default: {
      fields: ["id", "filename", "wkt"]
    }
  },
  listViews: {
    default: {
      fields: ["id"]
    }
  },
  fields: [
    coreFields.id,
    {
      title: "File name",
      source: "filename",
      ttoken: "common.filename",
      type: "text",
      readonly: true
    },
    commonFields.wkt
  ]
}

export default Photo360;
